/**
 * CDMX Scripts 2022
 * CDMXInfobox Header Scripts
 */

$('[data-toggle="tooltip"]').tooltip();
$("#cdmx-locatel-chatbot-panel").hide('slow');

$('#cdmx-llave-popup-message-close').click(function() {
    $("#cdmx-llave-popup-message").hide('slow');
});

$("#cdmx-locatel-chatbot-toggle-button").click(function() {
    $("#cdmx-locatel-chatbot-panel").toggle("slow");
});
$("#cdmx-locatel-chatbot-panel-close").click(function() {
    $("#cdmx-locatel-chatbot-panel").hide("slow");
});

$(document).on('click', "#cdmx-infobox-toggle-button", function(event) {
    if (!$("#cdmx-infobox-mobile-collapsable").is(":visible")) {
        $(this).html('<div class="cdmx-infobox-mobile-chevron-up"></div>');
    } else {
        $(this).html('<div class="cdmx-infobox-mobile-chevron-down"></div>');
    }
    $("#cdmx-infobox-mobile-collapsable").toggle("slow");
});
